import { addressActions } from './../../address/address.actions'
import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { of, Subject } from 'rxjs'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { organizationActions } from '../organization.actions'
import { catchError, take, timeout } from 'rxjs/operators'
import { NotificationService } from 'src/app/core/notification.service'
import { Address } from '../../address/address'
import { environment } from 'src/environments/environment'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'

@Component({
  selector: 'organization-create',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class OrganizationCreateComponent implements OnInit {
  public address: Partial<Address> = new Address()
  public disableSaveButton$: Subject<boolean> = new Subject<boolean>()
  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.disableSaveButton$.next(false)
  }
  public onSubmit(form): void {
    this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(take(1))
      .subscribe((pUr) => {
        const siteId =
          pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId

        const formOrg = { ...form }
        delete formOrg?.address
        this.store.dispatch(
          organizationActions.createOne({
            entity: {
              ...formOrg,
              siteId: siteId
            }
          })
        )
        this.actions$
          .pipe(
            ofType(organizationActions.upsertMany),
            take(1),
            timeout(1000),
            catchError((error) => of(null))
          )
          .subscribe((action) => {
            this.disableSaveButton$.next(false)
            if (action) {
              this.notificationService.emit('alerts.success', 'success')
              this.store.dispatch(
                addressActions.createOne({
                  entity: {
                    ...form.address,
                    ...this.address,
                    siteId: siteId,
                    organizationId: action.entities[0]?.id,
                    externalKey: ''
                  }
                })
              )
              this.router.navigate(
                [`/organizations`, action?.entities[0]?.id],
                {
                  queryParams: { disableSaveButton: true }
                }
              )
            }
          })
      })
  }
}
